import React from 'react';
import { SVGHeader } from '../../../../Svg/Header';
import { RecentListName, RecentSearchList } from '../Recent/styled';
import { trendingSearchDataConstant } from '../constant';
import { TrendingSearchHeading } from './styled';
import { useRouter } from 'next/router';
import { isDesktopUser } from '../../../../Utils/ProductUtils';

export default function TrendingSearches(props) {
  const { trendingSearchClickHandler } = props;
  const heading = ' Trending Searches on Mylo';
  const router = useRouter();

  return (
    <ul>
      <TrendingSearchHeading>{heading}</TrendingSearchHeading>
      {trendingSearchDataConstant?.map((element, index) => {
        return (
          <li key={`trendingSearch${index}`}>
            <RecentSearchList>
              <SVGHeader id="trending-black" width="18px" height="18px" />
              <RecentListName
                onClick={(event) => {
                  event.stopPropagation();
                  if (element.url && !isDesktopUser()) {
                    router.replace(element.url);
                  } else {
                    trendingSearchClickHandler(element.name, index);
                  }
                }}
              >
                {element.name}
              </RecentListName>
            </RecentSearchList>
          </li>
        );
      })}
    </ul>
  );
}
